import { render, staticRenderFns } from "./TwoBottomBtn.vue?vue&type=template&id=2aa2153c&scoped=true&"
import script from "./TwoBottomBtn.vue?vue&type=script&lang=js&"
export * from "./TwoBottomBtn.vue?vue&type=script&lang=js&"
import style0 from "./TwoBottomBtn.vue?vue&type=style&index=0&id=2aa2153c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa2153c",
  null
  
)

export default component.exports